export { default } from './LazySolvedSkills';
